/** Hide cart rows immediately when removal starts. */
(function () {
  /** Hide one or more elements from layout instantly. */
  const hide = (...els) =>
    els.forEach((el) => {
      if (!el) return;
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
    });

  /** True when link is a cart/change remove action (quantity 0). */
  const isRemoveLink = (a) => {
    try {
      const u = new URL(a.href, location.origin);
      return u.pathname.includes('/cart/change') && u.searchParams.get('quantity') === '0';
    } catch {
      return false;
    }
  };

  /** Hide drawer line item (and nested add-ons) before theme finishes removal. */
  document.addEventListener(
    'line-item:will-change',
    (e) => {
      const line = e.target;
      if (line?.tagName !== 'LINE-ITEM' || Number(e.detail?.targetQuantity) !== 0) return;

      const addon = line.closest('.cust-charm-cart__addon-item');
      if (addon) return hide(addon);

      const list = line.nextElementSibling;
      hide(line, list?.matches('.cust-charm-cart__addon-list') ? list : null);
    },
    true,
  );

  /** On cart page: hide parent + add-ons, then batch-remove and reload. */
  document.addEventListener(
    'click',
    (e) => {
      const a = e.target.closest('a[href*="/cart/change"]');
      if (!isRemoveLink(a)) return;

      const row = a.closest('tr[data-line-key]');
      if (!row || row.dataset.addonGroup === '1') return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const pid = row.dataset.variantId || '';
      const rows = [
        row,
        ...document.querySelectorAll(
          `tr[data-line-key][data-addon-group="1"][data-parent-variant-id="${CSS.escape(pid)}"]`,
        ),
      ];
      hide(...rows);

      const updates = {};
      rows.forEach((r) => {
        if (r.dataset.lineKey) updates[r.dataset.lineKey] = 0;
      });

      fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates }),
      }).finally(() => location.reload());
    },
    true,
  );
})();
